import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useTranslate } from '../../mixins/translate/translate';
import { check } from '../../store/authentication/actions';
import { IStoreState } from '../../store/IStoreState';
import { openApiFetchDelete, openApiFetchPost } from '../../store/openApiFetch';
import { useOpenApiFetch } from '../../store/useOpenApiFetch';
import { Modal } from '../common/Modal/Modal';
import {
    EditPanelButton,
    EditPanelCell,
    EditPanelExplanation,
    EditPanelHeader,
    EditPanelInput,
    EditPanelLabel,
    EditPanelRow,
    EditPanelSection,
    PanelButtonLink,
} from '../elements';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ChangeTwoFactorAuthentication = () => {
    const translate = useTranslate();
    const dispatch = useDispatch();
    const [isOptDialogVisible, setIsOptDialogVisible] = React.useState(false);
    const hasOtpEnabled = useSelector((state: IStoreState) => state.authentication.hasOtpEnabled ?? false);

    async function removeOtp() {
        await openApiFetchDelete('/api/user/otp', {});
        dispatch(check(false) as any); // TODO: ZXY-1109
        toast.info(translate('profile.twoFactorAuthenticationIsDisabled'), { autoClose: 3000 });
    }

    return (
        <>
            <EditPanelHeader text={translate('profile.twoFactorAuthentication')}></EditPanelHeader>
            {(hasOtpEnabled && (
                <>
                    <EditPanelRow>
                        <EditPanelLabel rowCount={6}>{translate('profile.twoFactorAuthenticationIsEnabled')}</EditPanelLabel>
                        <EditPanelCell rowCount={6}>
                            <PanelButtonLink text={translate('common.disable')} onClick={removeOtp} small mt icon="fa fa-power-off"></PanelButtonLink>
                        </EditPanelCell>
                    </EditPanelRow>
                    <EditPanelSection>
                        <EditPanelExplanation text={translate('profile.twoFactorAuthenticationExplanationDisable')} />
                    </EditPanelSection>
                </>
            )) || (
                <>
                    <EditPanelRow>
                        <EditPanelLabel rowCount={6}>{translate('profile.twoFactorAuthenticationIsDisabled')}</EditPanelLabel>
                        <EditPanelCell rowCount={6}>
                            <PanelButtonLink
                                text={translate('common.enable')}
                                onClick={() => setIsOptDialogVisible(true)}
                                small
                                primary
                                mt
                                icon="fa fa-power-off"
                            ></PanelButtonLink>
                        </EditPanelCell>
                    </EditPanelRow>
                    <EditPanelSection>
                        <EditPanelExplanation text={translate('profile.twoFactorAuthenticationExplanation')} />
                    </EditPanelSection>
                </>
            )}

            {isOptDialogVisible && <OptDialog onClose={() => setIsOptDialogVisible(false)} />}
        </>
    );
};

function OptDialog(props: { onClose: () => void }) {
    const translate = useTranslate();
    const dispatch = useDispatch();
    const { data } = useOpenApiFetch('/api/user/otp/getQrCode', 'get', {}, []);
    const [token, setToken] = React.useState('');
    const [isInvalidTokenMessageVisible, setIsInvalidTokenMessageVisible] = React.useState(false);
    const handleCloseFormClicked = () => {
        props.onClose();
    };

    async function saveSecret() {
        setIsInvalidTokenMessageVisible(false);
        if (data && token) {
            const response = await openApiFetchPost('/api/user/otp/secret', {}, { secret: data.secret, token });
            if (response.isValid) {
                dispatch(check(false) as any); // TODO: ZXY-1109
                props.onClose();
                toast.info(translate('profile.twoFactorAuthenticationIsEnabled'), { autoClose: 3000 });
            } else {
                setIsInvalidTokenMessageVisible(true);
            }
        }
    }

    return (
        <Modal id="copy-dialog" classNames="confirm-dialog" closeOnBackdropClick={true} onClose={() => handleCloseFormClicked()}>
            <Modal.Content isScrollBarVisible={true} style={{ height: '470px' }}>
                <div className="admin-form theme-primary">
                    <EditPanelSection>1. {translate('profile.twoFactorAuthenticationStepOne')}</EditPanelSection>
                    <EditPanelSection>
                        <img src={data?.qrCodeDataUrl} />
                    </EditPanelSection>
                    <EditPanelSection>2. {translate('profile.twoFactorAuthenticationStepTwo')}</EditPanelSection>
                    <EditPanelRow>
                        <EditPanelCell rowCount={6}>
                            <EditPanelInput
                                name="otpCode"
                                placeholder={translate('profile.otpCode')}
                                value={token}
                                maxlength={6}
                                handleChange={(e) => setToken(e)}
                                notValid={isInvalidTokenMessageVisible}
                                handleEnter={async () => saveSecret()}
                                autoFocus
                            />
                            {isInvalidTokenMessageVisible && <em className="state-error">{translate('login.otpCodeInvalid')}</em>}
                        </EditPanelCell>
                    </EditPanelRow>
                </div>
            </Modal.Content>
            <Modal.Actions>
                <EditPanelButton small={true} text={translate('common.cancel')} onClick={() => handleCloseFormClicked()} />
                <EditPanelButton small={true} primary={true} text={translate('common.save')} onClick={saveSecret} />
            </Modal.Actions>
        </Modal>
    );
}
